const systemFieldNames = {
	all: ['Name', 'CreatedBy', 'Created', 'ModifiedBy', 'Modified', 'Id'],
	notVisible: ['CreatedBy', 'Created', 'ModifiedBy', 'Modified', 'Id'],
	partiallyManaged: ['Name']
}

export default systemFieldNames
